import { SvgIconType } from './svg.interface';

const ListIcon: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#3AA5DC'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 1.5V12L9.375 10.5L7.6875 12L6 10.5L4.3125 12L2.625 10.5L0.75 12V1.5C0.75 0.671573 1.42157 0 2.25 0H9.75C10.5784 0 11.25 0.671573 11.25 1.5ZM3 4.5C2.58579 4.5 2.25 4.83579 2.25 5.25C2.25 5.66421 2.58579 6 3 6H9C9.41421 6 9.75 5.66421 9.75 5.25C9.75 4.83579 9.41421 4.5 9 4.5H3ZM5.25 6.75C4.83579 6.75 4.5 7.08579 4.5 7.5C4.5 7.91421 4.83579 8.25 5.25 8.25H9C9.41421 8.25 9.75 7.91421 9.75 7.5C9.75 7.08579 9.41421 6.75 9 6.75H5.25ZM3 2.25C2.58579 2.25 2.25 2.58579 2.25 3C2.25 3.41421 2.58579 3.75 3 3.75H9C9.41421 3.75 9.75 3.41421 9.75 3C9.75 2.58579 9.41421 2.25 9 2.25H3Z"
      fill={color}
    />
  </svg>
);

export default ListIcon;
